module.exports = __webpack_public_path__ + "static/media/logo-2.e5e3659d.png";